export default {
  components: {
    hotIcon: () => import('~/components/Atoms/Icon/Icon.vue'),
  },

  props: {
    label: {
      type: String,
      required: true,
    },

    links: {
      type: Array,
      required: true,
      default: () => [],
    },
  },

  methods: {
    toggle(event) {
      event.target.classList.toggle('dropdown--open')
    },
  },
}
